/**
 * KAME FIRE - Website Scripts
 * Bilingual support (ES/EN) and interactivity
 */

// ========================================
// TRANSLATIONS
// ========================================

const translations = {
    es: {
        // Navigation
        'nav.product': 'Producto',
        'nav.features': 'Caracteristicas',
        'nav.about': 'Nosotros',
        'nav.contact': 'Contacto',
        'nav.cta': 'Comprar',

        // Hero
        'hero.badge': 'KAMADOS PREMIUM',
        'hero.title1': 'Encuentra',
        'hero.title2': 'tu fuego.',
        'hero.subtitle': 'El arte del fuego lento. Cada asado es un ritual que transforma los espacios en territorios propios.',
        'hero.cta1': 'Descubrir el Kamado',
        'hero.cta2': 'Nuestra Historia',
        'hero.scroll': 'Desliza para explorar',

        // Product
        'product.tag': 'PRODUCTO INSIGNIA',
        'product.title': 'Kame Fire Kamado',
        'product.subtitle': 'Un kamado completamente equipado, listo para transformar cada momento en un ritual de fuego y sabor.',
        'product.badge': 'COMPLETAMENTE EQUIPADO',
        'product.priceLabel': 'Precio',
        'product.specsTitle': 'Especificaciones',
        'product.spec1': 'Ceramica de alta densidad',
        'product.spec2': 'Area de coccion: 46cm diametro',
        'product.spec3': 'Termometro integrado de precision',
        'product.spec4': 'Carro con mesas laterales incluido',
        'product.spec5': 'Garantia de 5 anos en ceramica',
        'product.buyBtn': 'Solicitar Cotizacion',
        'product.moreBtn': 'Ver Accesorios Incluidos',

        // Features
        'features.tag': 'CARACTERISTICAS',
        'features.title': 'El arte del fuego lento',
        'features.subtitle': 'La tortuga nos guia con paciencia, recordandonos que el camino tambien se honra en el disfrute.',
        'features.f1Title': 'Control Preciso',
        'features.f1Desc': 'Temperatura de 80C a 400C con control milimetrico. Perfecto para ahumados lentos o pizzas en minutos.',
        'features.f2Title': 'Eficiencia Termica',
        'features.f2Desc': 'La ceramica de alta densidad retiene el calor por horas con minimo consumo de carbon.',
        'features.f3Title': 'Versatilidad Total',
        'features.f3Desc': 'Asar, ahumar, hornear, rostizar. Un solo equipo para todas las tecnicas de coccion.',
        'features.f4Title': 'Calidad Premium',
        'features.f4Desc': 'Materiales de primera linea y acabados impecables. Disenado para durar generaciones.',
        'features.f5Title': 'Soporte Local',
        'features.f5Desc': 'Atencion personalizada desde Medellin. Entrega, instalacion y capacitacion incluidas.',
        'features.f6Title': 'Comunidad Kame',
        'features.f6Desc': 'Acceso a recetas exclusivas, eventos y una comunidad de apasionados por el fuego.',

        // Accessories
        'accessories.tag': 'INCLUIDO',
        'accessories.title': 'Todo lo que necesitas',
        'accessories.subtitle': 'Tu Kame Fire viene completamente equipado. Sin costos ocultos, sin sorpresas.',
        'accessories.allTitle': 'Todos los accesorios incluidos',
        'accessories.a1': 'Parrilla Principal',
        'accessories.a1Desc': 'Acero inoxidable para coccion directa',
        'accessories.a2': 'Deflector de Calor',
        'accessories.a2Desc': 'Ceramica para coccion indirecta',
        'accessories.a3': 'Piedra para Pizza',
        'accessories.a3Desc': 'Media luna para pizzas perfectas',
        'accessories.a4': 'Soporte Multi-nivel',
        'accessories.a4Desc': 'Duplica tu area de coccion',
        'accessories.a5': 'Soporte para Costillas',
        'accessories.a5Desc': 'Cocina costillares de pie',
        'accessories.a6': 'Soporte para Pollo',
        'accessories.a6Desc': 'Ceramica para pollo jugoso',
        'accessories.a7': 'Canastilla para Carbon',
        'accessories.a7Desc': 'Divide zonas de calor',
        'accessories.a8': 'Carro con Mesas',
        'accessories.a8Desc': 'Ruedas y mesas laterales',

        // About
        'about.tag': 'NUESTRA HISTORIA',
        'about.title': 'Somos los que convierten el instante en legado',
        'about.p1': 'El fuego abre sus alas como un abanico sagrado. Cada asado es un acto de proteccion y poder, un ritual que transforma los espacios en territorios propios.',
        'about.p2': 'La tortuga nos guia con paciencia, recordandonos que el camino tambien se honra en el disfrute. Desde Medellin, Colombia, llevamos el arte del fuego lento a quienes buscan mas que cocinar: buscan crear momentos que perduran.',
        'about.v1': 'Exploradores',
        'about.v2': 'Sabios',
        'about.v3': 'Maestros del Fuego',

        // Quote
        'quote.text': 'Donde el fuego nos une',

        // Contact
        'contact.tag': 'CONTACTO',
        'contact.title': 'Encuentra tu fuego',
        'contact.subtitle': 'Estamos en Medellin, Colombia. Escribenos para agendar una demostracion o resolver cualquier duda sobre tu futuro Kame Fire.',
        'contact.emailLabel': 'Email',
        'contact.phoneLabel': 'Telefono',
        'contact.locationLabel': 'Ubicacion',
        'contact.nameLabel': 'Nombre',
        'contact.formEmailLabel': 'Email',
        'contact.formPhoneLabel': 'Telefono',
        'contact.messageLabel': 'Mensaje',
        'contact.submitBtn': 'Enviar Mensaje',

        // Footer
        'footer.tagline': 'Maestros del Fuego',
        'footer.navTitle': 'Navegacion',
        'footer.contactTitle': 'Contacto',
        'footer.rights': 'Todos los derechos reservados.',
        'footer.craft': 'Hecho con fuego en Colombia'
    },
    en: {
        // Navigation
        'nav.product': 'Product',
        'nav.features': 'Features',
        'nav.about': 'About',
        'nav.contact': 'Contact',
        'nav.cta': 'Buy Now',

        // Hero
        'hero.badge': 'PREMIUM KAMADOS',
        'hero.title1': 'Find',
        'hero.title2': 'your fire.',
        'hero.subtitle': 'The art of slow fire. Every barbecue is a ritual that transforms spaces into your own territory.',
        'hero.cta1': 'Discover the Kamado',
        'hero.cta2': 'Our Story',
        'hero.scroll': 'Scroll to explore',

        // Product
        'product.tag': 'FLAGSHIP PRODUCT',
        'product.title': 'Kame Fire Kamado',
        'product.subtitle': 'A fully equipped kamado, ready to transform every moment into a ritual of fire and flavor.',
        'product.badge': 'FULLY EQUIPPED',
        'product.priceLabel': 'Price',
        'product.specsTitle': 'Specifications',
        'product.spec1': 'High-density ceramic',
        'product.spec2': 'Cooking area: 46cm diameter',
        'product.spec3': 'Precision built-in thermometer',
        'product.spec4': 'Cart with side tables included',
        'product.spec5': '5-year ceramic warranty',
        'product.buyBtn': 'Request Quote',
        'product.moreBtn': 'View Included Accessories',

        // Features
        'features.tag': 'FEATURES',
        'features.title': 'The art of slow fire',
        'features.subtitle': 'The turtle guides us with patience, reminding us that the journey is also honored in enjoyment.',
        'features.f1Title': 'Precise Control',
        'features.f1Desc': 'Temperature from 80C to 400C with millimetric control. Perfect for slow smoking or pizzas in minutes.',
        'features.f2Title': 'Thermal Efficiency',
        'features.f2Desc': 'High-density ceramic retains heat for hours with minimal charcoal consumption.',
        'features.f3Title': 'Total Versatility',
        'features.f3Desc': 'Grill, smoke, bake, roast. One equipment for all cooking techniques.',
        'features.f4Title': 'Premium Quality',
        'features.f4Desc': 'First-class materials and impeccable finishes. Designed to last generations.',
        'features.f5Title': 'Local Support',
        'features.f5Desc': 'Personalized attention from Medellin. Delivery, installation and training included.',
        'features.f6Title': 'Kame Community',
        'features.f6Desc': 'Access to exclusive recipes, events and a community passionate about fire.',

        // Accessories
        'accessories.tag': 'INCLUDED',
        'accessories.title': 'Everything you need',
        'accessories.subtitle': 'Your Kame Fire comes fully equipped. No hidden costs, no surprises.',
        'accessories.allTitle': 'All included accessories',
        'accessories.a1': 'Main Grill',
        'accessories.a1Desc': 'Stainless steel for direct grilling',
        'accessories.a2': 'Heat Deflector',
        'accessories.a2Desc': 'Ceramic for indirect cooking',
        'accessories.a3': 'Pizza Stone',
        'accessories.a3Desc': 'Half-moon for perfect pizzas',
        'accessories.a4': 'Multi-level Rack',
        'accessories.a4Desc': 'Doubles your cooking space',
        'accessories.a5': 'Rib Rack',
        'accessories.a5Desc': 'Cooks rib racks standing up',
        'accessories.a6': 'Chicken Roaster',
        'accessories.a6Desc': 'Ceramic for juicy chicken',
        'accessories.a7': 'Charcoal Basket',
        'accessories.a7Desc': 'Divides heat zones',
        'accessories.a8': 'Cart with Tables',
        'accessories.a8Desc': 'Wheels and side tables',

        // About
        'about.tag': 'OUR STORY',
        'about.title': 'We are those who turn moments into legacy',
        'about.p1': 'Fire spreads its wings like a sacred fan. Every barbecue is an act of protection and power, a ritual that transforms spaces into your own territory.',
        'about.p2': 'The turtle guides us with patience, reminding us that the journey is also honored in enjoyment. From Medellin, Colombia, we bring the art of slow fire to those who seek more than cooking: they seek to create moments that last.',
        'about.v1': 'Explorers',
        'about.v2': 'Sages',
        'about.v3': 'Fire Masters',

        // Quote
        'quote.text': 'Where fire unites us',

        // Contact
        'contact.tag': 'CONTACT',
        'contact.title': 'Find your fire',
        'contact.subtitle': 'We are in Medellin, Colombia. Write to us to schedule a demo or resolve any questions about your future Kame Fire.',
        'contact.emailLabel': 'Email',
        'contact.phoneLabel': 'Phone',
        'contact.locationLabel': 'Location',
        'contact.nameLabel': 'Name',
        'contact.formEmailLabel': 'Email',
        'contact.formPhoneLabel': 'Phone',
        'contact.messageLabel': 'Message',
        'contact.submitBtn': 'Send Message',

        // Footer
        'footer.tagline': 'Fire Masters',
        'footer.navTitle': 'Navigation',
        'footer.contactTitle': 'Contact',
        'footer.rights': 'All rights reserved.',
        'footer.craft': 'Made with fire in Colombia'
    }
};

// ========================================
// LANGUAGE HANDLING
// ========================================

let currentLang = 'es';

function setLanguage(lang) {
    currentLang = lang;
    document.documentElement.lang = lang;

    // Update all translatable elements
    document.querySelectorAll('[data-i18n]').forEach(element => {
        const key = element.getAttribute('data-i18n');
        if (translations[lang] && translations[lang][key]) {
            element.textContent = translations[lang][key];
        }
    });

    // Update language toggle display
    const langToggle = document.getElementById('langToggle');
    if (langToggle) {
        const spans = langToggle.querySelectorAll('span');
        if (lang === 'es') {
            spans[0].classList.add('lang-active');
            spans[0].classList.remove('lang-inactive');
            spans[2].classList.remove('lang-active');
            spans[2].classList.add('lang-inactive');
        } else {
            spans[0].classList.remove('lang-active');
            spans[0].classList.add('lang-inactive');
            spans[2].classList.add('lang-active');
            spans[2].classList.remove('lang-inactive');
        }
    }

    // Store preference
    localStorage.setItem('kamefire-lang', lang);
}

function toggleLanguage() {
    const newLang = currentLang === 'es' ? 'en' : 'es';
    setLanguage(newLang);
}

// ========================================
// NAVIGATION
// ========================================

function initNavigation() {
    const nav = document.getElementById('nav');
    const navMenuBtn = document.getElementById('navMenuBtn');
    const mobileMenu = document.getElementById('mobileMenu');

    // Scroll handler for nav background
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;

        if (currentScroll > 100) {
            nav.classList.add('scrolled');
        } else {
            nav.classList.remove('scrolled');
        }

        lastScroll = currentScroll;
    });

    // Mobile menu toggle
    if (navMenuBtn && mobileMenu) {
        navMenuBtn.addEventListener('click', () => {
            navMenuBtn.classList.toggle('active');
            mobileMenu.classList.toggle('active');
            document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
        });

        // Close mobile menu on link click
        mobileMenu.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', () => {
                navMenuBtn.classList.remove('active');
                mobileMenu.classList.remove('active');
                document.body.style.overflow = '';
            });
        });
    }

    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                const headerOffset = 80;
                const elementPosition = target.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
}

// ========================================
// FORM HANDLING
// ========================================

function initContactForm() {
    const form = document.getElementById('contactForm');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const formData = new FormData(form);
        const data = Object.fromEntries(formData);

        // Show loading state
        const submitBtn = form.querySelector('button[type="submit"]');
        const originalText = submitBtn.textContent;
        submitBtn.textContent = currentLang === 'es' ? 'Enviando...' : 'Sending...';
        submitBtn.disabled = true;

        // Simulate form submission (replace with actual endpoint)
        try {
            // In production, you would send to your backend:
            // await fetch('/api/contact', {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify(data)
            // });

            // Simulate delay
            await new Promise(resolve => setTimeout(resolve, 1500));

            // Success message
            const successMessage = currentLang === 'es'
                ? 'Gracias por tu mensaje. Te contactaremos pronto.'
                : 'Thank you for your message. We will contact you soon.';

            alert(successMessage);
            form.reset();

        } catch (error) {
            const errorMessage = currentLang === 'es'
                ? 'Hubo un error. Por favor intenta de nuevo.'
                : 'There was an error. Please try again.';

            alert(errorMessage);
        } finally {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
        }
    });
}

// ========================================
// SCROLL ANIMATIONS
// ========================================

function initScrollAnimations() {
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // Add animation classes to elements
    const animatedElements = document.querySelectorAll(
        '.feature-card, .accessory-item, .product-details, .about-text, .about-visual'
    );

    animatedElements.forEach(el => {
        el.classList.add('fade-in');
        observer.observe(el);
    });

    // Accessory scroll cards animation
    initAccessoryScrollAnimation();
}

// ========================================
// ACCESSORY SCROLL ANIMATION
// ========================================

function initAccessoryScrollAnimation() {
    const scrollCards = document.querySelectorAll('.accessory-scroll-card');
    const kamadoImg = document.querySelector('.kamado-showcase-img');
    const highlight = document.getElementById('accessoryHighlight');

    if (scrollCards.length === 0) return;

    const cardObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Add visible class to animate the card in
                entry.target.classList.add('visible');

                // Animate the kamado image
                if (kamadoImg) {
                    kamadoImg.style.transform = 'scale(1.02)';
                }

                // Show highlight effect
                if (highlight) {
                    highlight.classList.add('active');
                }
            } else {
                // Reset when card leaves viewport
                if (kamadoImg) {
                    kamadoImg.style.transform = 'scale(1)';
                }
                if (highlight) {
                    highlight.classList.remove('active');
                }
            }
        });
    }, {
        root: null,
        rootMargin: '-20% 0px -20% 0px',
        threshold: 0.3
    });

    scrollCards.forEach(card => {
        cardObserver.observe(card);
    });

    // Parallax effect on scroll for kamado image
    if (kamadoImg) {
        window.addEventListener('scroll', () => {
            const scrollY = window.scrollY;
            const section = document.querySelector('.accessories-showcase');
            if (section) {
                const sectionTop = section.offsetTop;
                const sectionHeight = section.offsetHeight;
                if (scrollY >= sectionTop - window.innerHeight && scrollY <= sectionTop + sectionHeight) {
                    const progress = (scrollY - sectionTop + window.innerHeight) / (sectionHeight + window.innerHeight);
                    const rotation = -5 + (progress * 10);
                    kamadoImg.style.transform = `perspective(1000px) rotateY(${rotation}deg)`;
                }
            }
        }, { passive: true });
    }
}

// ========================================
// ACCESSORIES MODAL (optional future feature)
// ========================================

function initAccessoriesModal() {
    const moreBtn = document.querySelector('[data-i18n="product.moreBtn"]');
    if (!moreBtn) return;

    moreBtn.addEventListener('click', () => {
        // Scroll to accessories section
        const accessoriesSection = document.getElementById('accesorios');
        if (accessoriesSection) {
            const headerOffset = 80;
            const elementPosition = accessoriesSection.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    });
}

// ========================================
// INITIALIZATION
// ========================================

document.addEventListener('DOMContentLoaded', () => {
    // Check for stored language preference
    const storedLang = localStorage.getItem('kamefire-lang');
    if (storedLang && (storedLang === 'es' || storedLang === 'en')) {
        setLanguage(storedLang);
    }

    // Initialize components
    initNavigation();
    initContactForm();
    initScrollAnimations();
    initAccessoriesModal();

    // Language toggle event
    const langToggle = document.getElementById('langToggle');
    if (langToggle) {
        langToggle.addEventListener('click', toggleLanguage);
    }

    // Add CTA button functionality
    document.querySelectorAll('.nav-cta, .mobile-cta').forEach(btn => {
        btn.addEventListener('click', () => {
            const contactSection = document.getElementById('contacto');
            if (contactSection) {
                const headerOffset = 80;
                const elementPosition = contactSection.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });

    console.log('Kame Fire website initialized');
});

// ========================================
// PERFORMANCE OPTIMIZATIONS
// ========================================

// Lazy load images (if you add actual images later)
if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                if (img.dataset.src) {
                    img.src = img.dataset.src;
                    img.removeAttribute('data-src');
                }
                observer.unobserve(img);
            }
        });
    });

    document.querySelectorAll('img[data-src]').forEach(img => {
        imageObserver.observe(img);
    });
}

// Preload critical assets
function preloadAssets() {
    const preloadLinks = [
        { href: 'https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;600;700&display=swap', as: 'style' }
    ];

    preloadLinks.forEach(({ href, as }) => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.href = href;
        link.as = as;
        document.head.appendChild(link);
    });
}

// ========================================
// UTILITY FUNCTIONS
// ========================================

// Debounce function for scroll events
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Throttle function for animations
function throttle(func, limit) {
    let inThrottle;
    return function(...args) {
        if (!inThrottle) {
            func.apply(this, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
        }
    };
}
